import { APP } from '../tokens';
import type { PermissionTier } from '@corner/shared';

const F = APP.fontFamily;

const TIER_COLORS: Record<PermissionTier, string> = {
  Read:    '#22C55E',
  Propose: '#3B82F6',
  Apply:   '#F59E0B',
  Send:    '#EF4444',
};

const TOOL_FRIENDLY_NAMES: Record<string, string> = {
  plan_doc_edits: 'edit this document',
  fill_pdf_form:  'fill form fields',
  esign:          'apply signature',
  sign_document:  'sign this field',
};

interface CoTConfirmCardProps {
  toolName: string;
  description: string;
  permissionTier: PermissionTier;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function CoTConfirmCard({
  toolName,
  description,
  permissionTier,
  onConfirm,
  onCancel,
}: CoTConfirmCardProps) {
  const color = TIER_COLORS[permissionTier] ?? TIER_COLORS.Apply;
  const friendlyName = TOOL_FRIENDLY_NAMES[toolName] ?? toolName.replace(/_/g, ' ');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 6,
        paddingBlock: 8,
        paddingInline: 10,
        gap: 8,
        backgroundColor: `${color}0F`,
        border: `1px solid ${color}26`,
      }}
    >
      {/* Tier badge */}
      <span
        style={{
          display: 'inline-flex',
          alignSelf: 'flex-start',
          fontSize: 9,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          padding: '2px 6px',
          borderRadius: 3,
          color: '#fff',
          backgroundColor: color,
          fontFamily: F,
        }}
      >
        {permissionTier}
      </span>

      {/* Description */}
      <span
        style={{
          fontSize: 11,
          fontWeight: 400,
          color: APP.textPrimary,
          lineHeight: '16px',
          fontFamily: F,
        }}
      >
        Corner wants to <strong>{friendlyName}</strong>
        {description ? `: ${description}` : '.'}
      </span>

      {/* Actions */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={onConfirm}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 4,
            paddingBlock: 4,
            paddingInline: 10,
            gap: 4,
            backgroundColor: color,
            border: 'none',
            cursor: 'pointer',
            fontFamily: F,
            fontSize: 11,
            fontWeight: 600,
            color: '#FFFFFF',
            lineHeight: '14px',
          }}
        >
          {permissionTier === 'Send' ? 'Send' : 'Confirm'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          style={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 4,
            paddingBlock: 4,
            paddingInline: 10,
            backgroundColor: 'transparent',
            border: `1px solid ${APP.border}`,
            cursor: 'pointer',
            fontFamily: F,
            fontSize: 11,
            fontWeight: 500,
            color: APP.textCardDetail,
            lineHeight: '14px',
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
